export default {
    // api请求地址
    baseUrl: "https://b2b.tuzhiyiyao.cn/",  
    // 图片域名
    imgDomain: "https://b2b.tuzhiyiyao.cn/",
    // 前端域名
    webDomain: "",
    // 腾讯地图key
    mpKey: "",
    // 客服
    webSocket: "",
    //本地端主动给服务器ping的时间, 0 则不开启 , 单位秒
    pingInterval: 1500,
    // 客服地址
    keFuUrl: "",
}
